import React from 'react';
import Button from '@grnhse/seedling/lib/azalea/components/button';
import { withLocalePrefix } from 'shared/utils/translation';

const t = withLocalePrefix('gdpr.shared');

type Props = {
  dataProvides: string;
  onClick: any;
};

export default function AddARule(props: Props) {
  return (
    <Button onClick={props.onClick} data-provides={props.dataProvides}>
      {t('add_a_rule')}
    </Button>
  );
}
